import ClaudeLogo from '../components/resources/images/claude.svg';

export type KnownOAuthClient = {
  name: string;
  logo: string;
};

const KNOWN_OAUTH_CLIENTS: Readonly<Record<string, KnownOAuthClient>> = {
  'claude.ai': { name: 'Claude', logo: ClaudeLogo },
};

const hostMatchesDomain = (host: string, domain: string): boolean => host === domain || host.endsWith(`.${domain}`);

export const resolveOAuthClient = (redirectUri: string | null): KnownOAuthClient | null => {
  if (!redirectUri) {
    return null;
  }

  try {
    const { hostname } = new URL(redirectUri);
    const normalizedHost = hostname.toLowerCase();

    for (const [domain, client] of Object.entries(KNOWN_OAUTH_CLIENTS)) {
      if (hostMatchesDomain(normalizedHost, domain)) {
        return client;
      }
    }
  } catch {
    return null;
  }

  return null;
};
